import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { InventoryService } from '../../services/index';

@Component({
  selector: 'app-astmstr',
  templateUrl: './astmstr.component.html',
  styleUrls: ['./astmstr.component.scss'],
  providers:[InventoryService]
})
export class AstmstrComponent implements OnInit {

  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  tab=1;

  arraset:any=[];
  arrmjgrp:any=[];
  arrmngrp:any=[];

  arrinvmunit:any=[];
  arrinvmstore:any=[];
  arrinvmstcat:any=[];
  arrinvmmnttype:any=[];
  arrinvmmfr:any=[];
  arrbrand:any=[];
  asetmodel:any={};
  status = [
    {
      id: 1,
      name: 'Active'
    },
    {
      id: 2,
      name: 'Inactive'
    }
 ];

  constructor(private iservice: InventoryService,private modalService: NgbModal) { }

  opendialog(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.asetmodel={};
      this.asetmodel.astid=0;
      this.asetmodel.astno='';
      this.asetmodel.astnm='';
      this.asetmodel.igida='';
      this.asetmodel.igidb='';
      this.asetmodel.hsn='';
      this.asetmodel.bndid='0';
      this.asetmodel.mfrid='0';
      this.asetmodel.pdno='';
      this.asetmodel.model='';
      this.asetmodel.dom=this.iservice.getdatetoday();
      this.asetmodel.batchno='';
      this.asetmodel.stid='0';
      this.asetmodel.pono='';
      this.asetmodel.podt=this.iservice.getdatetoday();
      this.asetmodel.invno='';
      this.asetmodel.invdt=this.iservice.getdatetoday();
      this.asetmodel.mrp=0;
      this.asetmodel.prate=0;
      this.asetmodel.disc=0;
      this.asetmodel.qty=0;
      this.asetmodel.tamt=0;
      this.asetmodel.cgst=0;
      this.asetmodel.sgst=0;
      this.asetmodel.igst=0;
      this.asetmodel.namt=0;
      this.asetmodel.mntid='0';
      this.asetmodel.mntsdt=this.iservice.getdatetoday();
      this.asetmodel.mntedt=this.iservice.getdatetoday();
      this.asetmodel.rqty='0';
      this.asetmodel.rstatus='Active';
      this.asetmodel.crby=localStorage.getItem('usid');
      this.asetmodel.mdby='0';
      this.asetmodel.oprtype='insert';
    // `astid`, `astno`, `astnm`, `hsn`, `igida`, `igidb`, `bndid`, `mfrid`, `pdno`, `model`, `dom`, `batchno`, `stid`, `pono`, 
    //`podt`, `invno`, `invdt`, `mrp`
    // , `prate`, `disc`, `qty`, `tamt`, `cgst`, `sgst`, `igst`, `namt`, `mntid`, `mntsdt`, `mntedt`, `rqty`, `rstatus`, `crby`, `cron`, `mdby`, `mdon`

    }

    else if(cmd=='update')
    {
      this.asetmodel=objdata;
      this.asetmodel.mdby=localStorage.getItem('usid');
      this.asetmodel.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      //size:'sm'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  ngOnInit(): void {
    this.getassets();
    this.getinvmiga();
    this.getinvmigb();
    this.getinvmbrand();
    this.getinvmmfr();
    this.getinvmmnttype();
    this.getinvmstcat();
    this.getinvmstore();


  }


  getinvmiga() {
    this.iservice.getinvmiga()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrmjgrp = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  getinvmigb() {
    this.iservice.getinvmigb()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrmngrp = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }



  
  getinvmbrand() {
    this.iservice.getinvmbrand()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrbrand = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getinvmmfr() {
    this.iservice.getinvmmfr()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrinvmmfr = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getinvmmnttype() {
    this.iservice.getinvmmnttype()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrinvmmnttype = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  getinvmstcat() {
    this.iservice.getinvmstcat()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrinvmstcat = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getinvmstore() {
    this.iservice.getinvmstore()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrinvmstore = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getinvmunit() {
    this.iservice.getinvmunit()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrinvmunit = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  getassets() {
    this.iservice.getinvmasset()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arraset = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  SaveDetails()
  {
console.log('catsave',this.asetmodel);
    this.iservice.saveinvmasset(this.asetmodel)
        .subscribe(
        result => {

            console.log('savelibcategory', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              

            }
           else
           {

           }
        },
        error =>{ alert('Error While saving...');}
        )
  }
}
